import { countryNames } from '../../utils/constants'

export const filtersLiterals = {
  categoryType: {
    title: 'Category type',
    optionsLabels: ['Fraud Solution', 'Payment Method', 'Processor'],
  },
  countryCoverage: {
    title: 'Country coverage   ',
    optionsLabels: countryNames,
  },
}
